import React from 'react';

export default function DefinitionItem({ label, value, helper, emphasis = false }) {
  return (
    <div className="min-w-0">
      <dt className="text-xs font-medium uppercase tracking-wide text-subtle">
        {label}
      </dt>
      <dd
        className={`mt-1 tabular-nums text-primary ${
          emphasis ? "text-xl font-semibold" : "text-sm font-medium"
        }`}
      >
        {value || "N/C"}
      </dd>
      {helper && (
        <p className="mt-1 text-xs text-subtle">
          {helper}
        </p>
      )}
    </div>
  );
}
